import TwoWayMap from '../../map/two-way-map';

/**
 * Maps a transfer field to the corresponding 'orderBy' parameter in the Abuse API
 */
const SortModelMap = new TwoWayMap(new Map<string, string>([]));

export default SortModelMap;
